import { render, staticRenderFns } from "./SliderDuzenle.vue?vue&type=template&id=47c80e5f&scoped=true&"
import script from "./SliderDuzenle.vue?vue&type=script&lang=js&"
export * from "./SliderDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./SliderDuzenle.vue?vue&type=style&index=0&id=47c80e5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c80e5f",
  null
  
)

export default component.exports